import React, { PropsWithChildren } from 'react';
import { AppConfigContext } from 'Components/utils/AppBootstrapper/AppConfigContext';
import { setup } from './wasm_exec';
// eslint-disable-next-line
import './wasmTypes.d.ts';

export interface WasmContextValue {
  wasmLoaded: boolean;
  loadWasm: () => void;
}

export const WasmContext = React.createContext<WasmContextValue>(undefined);

export const WasmProvider: React.FC<PropsWithChildren> = ({ children }) => {
  const [wasmLoaded, setWasmLoaded] = React.useState(false);
  const appConfigContext = React.useContext(AppConfigContext);
  const pantherDataLakeType = appConfigContext?.[0]?.pantherDataLakeType;

  const loadWasm = React.useCallback(async () => {
    try {
      if (window.pfParse) {
        // can skip initialization if already previously loaded
        // eslint-disable-next-line
        console.warn('skipping wasm initialization');
        return;
      }
      setup();
      const go = new window.Go();
      const data = await fetch('/wasm/panther-flow.wasm');
      const contentType = data.headers.get('content-type');
      if (contentType !== 'application/wasm' || data.status !== 200) {
        throw new Error('no wasm file found');
      }
      const result = await WebAssembly.instantiateStreaming(data, go.importObject);
      go.run(result.instance);
      if (pantherDataLakeType && window.pfSetDataLakeType) {
        window.pfSetDataLakeType(pantherDataLakeType);
      }
      setWasmLoaded(true);
    } catch (e) {
      // eslint-disable-next-line
      console.error('failed to load panther-flow.wasm', e);
    }
  }, [setWasmLoaded, pantherDataLakeType]);

  React.useEffect(() => {
    if (wasmLoaded && pantherDataLakeType && window.pfSetDataLakeType) {
      window.pfSetDataLakeType(pantherDataLakeType);
    }
  }, [wasmLoaded, pantherDataLakeType]);

  const contextValue = React.useMemo(() => ({ wasmLoaded, loadWasm }), [wasmLoaded, loadWasm]);
  return <WasmContext.Provider value={contextValue}>{children}</WasmContext.Provider>;
};
